export const WDAC_STATUS = {
  Unknown: 'Unknown',
  Audit: 'Audit',
  Enforced: 'Enforced',
};

const WDAC_STATUS_MAPPING = [
  { value: WDAC_STATUS.Unknown, label: 'Unknown' },
  { value: WDAC_STATUS.Audit, label: 'Audit' },
  { value: WDAC_STATUS.Enforced, label: 'Enforced' },
];

export const getWdacStatusLabel = value =>
  WDAC_STATUS_MAPPING.find(item => item.value === value)?.label || 'Unknown';
